import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { CatFichaInmaterial } from 'src/app/models/CatFichaInmaterial';

@Component({
  selector: 'app-ModalInmaterial',
  templateUrl: './ModalInmaterial.component.html',
  styleUrls: ['./ModalInmaterial.component.css']
})
export class ModalInmaterialComponent implements OnInit {
  @Input() user: any;
  @Input() ficha: CatFichaInmaterial;

  model = {
    left: true,
    middle: false,
    right: false
  };
  

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }
  

}
